import { combineReducers } from "redux";
import { LoginComponent } from "./LoginReducer";

const reducers = combineReducers({
  LoginComponent,
  //other reducers come here...
});

export default reducers;